export const MONEY_INTEGER_ERROR = 'Enter a positive whole number.';
export const DOWN_PAYMENT_EXCEEDS_ERROR = 'Down payment cannot exceed the approved quotation.';

const containsForbiddenMoneyChars = (value) => {
  const text = String(value || '').trim();
  if (!text) return false;
  return /[kKmM₱$]|php|\./i.test(text.replace(/,/g, ''));
};

const toPositiveInteger = (digits) => {
  if (!/^\d+$/.test(String(digits || ''))) return null;
  const amount = Number(digits);
  if (!Number.isInteger(amount) || amount <= 0) return null;
  return amount;
};

export const parseIntegerMoney = (rawValue) => {
  const text = String(rawValue ?? '').trim();
  if (!text) return null;
  if (containsForbiddenMoneyChars(rawValue)) return null;
  return toPositiveInteger(text.replace(/,/g, ''));
};

export const parseStoredIntegerMoney = (rawValue) => {
  if (typeof rawValue === 'number') return toPositiveInteger(String(Math.trunc(rawValue)));
  const text = String(rawValue ?? '').trim();
  if (!text) return null;
  return toPositiveInteger(text.replace(/[^\d]/g, ''));
};

export const formatIntegerCommas = (value) => {
  const amount = typeof value === 'number'
    ? toPositiveInteger(String(Math.trunc(value)))
    : (parseIntegerMoney(value) ?? parseStoredIntegerMoney(value));
  if (!Number.isInteger(amount) || amount <= 0) return '';
  return amount.toLocaleString('en-US');
};

/** Display helper for public UI amounts (allows 0). */
export const formatDisplayAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '0';
  return Math.trunc(amount).toLocaleString('en-US');
};

export const toStoredIntegerMoney = (rawValue) => {
  const amount = parseIntegerMoney(rawValue) ?? parseStoredIntegerMoney(rawValue);
  return amount == null ? '' : String(amount);
};

export const stripMoneyInput = (rawValue) => String(rawValue || '').replace(/[^\d]/g, '');

export const normalizeMoneyTyping = (rawValue) => {
  const text = String(rawValue || '');
  if (!text.trim()) return '';
  if (containsForbiddenMoneyChars(text) || /[^\d,]/.test(text)) return text;
  return stripMoneyInput(text);
};

export const displayMoneyValue = (rawValue, { focused = false } = {}) => {
  if (focused) {
    const amount = parseIntegerMoney(rawValue);
    return amount == null ? String(rawValue || '') : String(amount);
  }
  const formatted = formatIntegerCommas(rawValue);
  if (formatted) return formatted;
  return String(rawValue || '');
};

export const validatePositiveIntegerMoney = (rawValue, { required = false } = {}) => {
  const text = String(rawValue ?? '').trim();
  if (!text) return required ? MONEY_INTEGER_ERROR : '';
  return parseIntegerMoney(rawValue) == null ? MONEY_INTEGER_ERROR : '';
};

export const validateDownPayment = (quotationValue, downPaymentValue) => {
  const quotationError = validatePositiveIntegerMoney(quotationValue);
  const downPaymentError = validatePositiveIntegerMoney(downPaymentValue);
  if (quotationError) return quotationError;
  if (downPaymentError) return downPaymentError;

  const quotation = parseIntegerMoney(quotationValue);
  const downPayment = parseIntegerMoney(downPaymentValue);
  if (quotation == null || downPayment == null) return '';
  if (downPayment > quotation) return DOWN_PAYMENT_EXCEEDS_ERROR;
  return '';
};
